import {
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  ModalBody,
  Button,
  Box,
  Avatar,
} from '@chakra-ui/react';
import React from 'react';
import { CheckCircle } from '@kula-ai/icons-core';
import { KText } from 'ui-library/components';

export const BulkError = ({
  total,
  contacts = [],
  renderContacts = false,
  modalActions = {},
  showAction = true,
  actionText = 'Close',
  successMessage = 'introductions in progress',
  mainText = 'intros have not been sent',
  mainSubText = "We didn't send an intro the following candidates due to an internal error. We apologize, please try again later.",
  onActionSubmit,
}) => {
  const { isOpen, onClose } = modalActions;

  const successCount = total - contacts?.length;

  const handleModalClose = () => {
    if (onActionSubmit) onActionSubmit(onClose);
    else onClose();
  };

  const renderContact = (contact = {}) => {
    const { id, first_name, last_name, image_url: src, position } = contact;
    const name = (first_name ? first_name : '') + (last_name ? last_name : '');
    return (
      <Flex key={id} p="18px 21px" gap="19px">
        <Avatar
          borderRadius="6px"
          width="36px"
          height="36px"
          className="avatar-sm"
          src={src}
          name={name}
        />
        <Flex flexDir="column" gap="4px">
          <KText size="md-semi-bold">{name}</KText>
          {position && <KText fontSize="md">{position}</KText>}
        </Flex>
      </Flex>
    );
  };

  const renderBody = () => {
    return (
      <Flex flexDir="column" gap="27px">
        {successCount > 0 && (
          <Flex
            w="100%"
            gap="9px"
            p="24px 12px"
            alignItems="center"
            justifyContent="center"
            border="1px solid"
            borderColor="border-color"
            borderRadius="sm"
          >
            <CheckCircle size="1em" color="#5BD275" className="kula-icon" />
            <KText size="lg-semi-bold">{successMessage}</KText>
          </Flex>
        )}
        <Flex flexDir="column" alignItems="center" gap="4px">
          <KText size="xl-semi-bold">
            Attention: {contacts?.length} {mainText}
          </KText>
          <KText size="md-regular" lineHeight="26px">
            {mainSubText}
          </KText>
        </Flex>
        {renderContacts && (
          <Flex
            border="1px solid"
            borderColor="border-color"
            borderRadius="sm"
            w="100%"
            flexDir="column"
          >
            <Box
              bgColor="#FAFAFA"
              p="20px"
              borderBottom="1px solid"
              borderTopRadius="sm"
              borderColor="border-color"
            >
              <KText>Name</KText>
            </Box>

            <Box overflowY="auto" maxH="221px">
              {contacts.map(renderContact)}
            </Box>
          </Flex>
        )}
      </Flex>
    );
  };

  const renderModal = () => {
    return (
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        isCentered
        onOverlayClick={handleModalClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalBody p="40px">{renderBody()}</ModalBody>
          {showAction && (
            <ModalFooter>
              <Button variant="primary" mr={3} onClick={handleModalClose}>
                {actionText}
              </Button>
            </ModalFooter>
          )}
        </ModalContent>
      </Modal>
    );
  };

  return <Flex>{renderModal()}</Flex>;
};
